import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getData, serverURL } from '../../services/FetchNodeServices';

const ITEMS_PER_PAGE = 10;

const AllBrand = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, totalPages: 1, page: 1 });
  const [loading, setLoading] = useState(false);

  const getApiData = async (page = 1) => {
    try {
      setLoading(true);
      const res = await getData(`brand/get-all-brand-with-pagination?page=${page}&limit=${ITEMS_PER_PAGE}`);
      if (res.status) {
        setData(res.data || []);
        setPagination(res.pagination || { total: 0, totalPages: 1, page });
      } else {
        toast.error(res.message || "Failed to fetch brands.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while fetching brands.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getApiData(1);
  }, []);

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    });

    if (confirm.isConfirmed) {
      try {
        const res = await getData(`brand/delete-brand/${id}`);
        if (res.status) {
          toast.success("Brand deleted successfully!");
          // If last item on page is deleted, go to previous page
          const newPage = data.length === 1 && pagination.page > 1 ? pagination.page - 1 : pagination.page;
          getApiData(newPage);
        } else {
          toast.error("Error deleting brand");
        }
      } catch (err) {
        console.error(err);
        toast.error("Something went wrong");
      }
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= pagination.totalPages) {
      getApiData(page);
    }
  };

  const renderPagination = () => {
    const pages = [];
    const { page, totalPages } = pagination;

    if (totalPages <= 1) return null;

    pages.push(1);
    if (page > 3) pages.push("...");

    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) {
      pages.push(i);
    }

    if (page < totalPages - 2) pages.push("...");
    if (totalPages > 1) pages.push(totalPages);

    return (
      <div className="d-flex justify-content-center mt-3 gap-2 flex-wrap">
        <button className="btn btn-sm btn-outline-dark" onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
          Previous
        </button>

        {pages.map((p, idx) =>
          p === "..." ? (
            <span key={`ellipsis-${idx}`} className="px-2">...</span>
          ) : (
            <button
              key={p}
              className={`btn btn-sm ${page === p ? "btn-dark" : "btn-outline-dark"}`}
              onClick={() => handlePageChange(p)}
            >
              {p}
            </button>
          )
        )}

        <button className="btn btn-sm btn-outline-dark" onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>
          Next
        </button>
      </div>
    );
  };

  console.log(data)
  return (
    <>
      <ToastContainer />
      <div className="bread">
        <div className="head">
          <h4>All Brand List</h4>
        </div>
        <div className="links">
          <Link to="/add-brand" className="add-new">Add New <i className="fa-solid fa-plus"></i></Link>
        </div>
      </div>

      <section className="d-table">
        {loading ? (
          <p className="text-center">Loading brands...</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped table-hover">
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Brand Category</th>
                  <th>Name</th>
                  <th>Image</th>
                  <th>Status</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(pagination.page - 1) * ITEMS_PER_PAGE + index + 1}</td>
                      <td>{item.brand_category_name || "—"}</td>
                      <td>{item.name}</td>
                      <td>
                        {item?.image ? (
                          <img
                            src={
                              item.image.startsWith("uploads/images")
                                ? `${serverURL}/${item.image}`
                                : `${serverURL}/uploads/images/${item.image}`
                            }
                            alt="brand"
                            width="50"
                          />
                        ) : (
                          <span>No Image</span>
                        )}
                      </td>
                      <td>{item.status === 1 ? "Active" : "Inactive"}</td>
                      <td>
                        <Link to={`/edit-brand/${item.id}`} className="btn btn-warning btn-sm">
                          Edit
                        </Link>
                      </td>
                      <td>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(item.id)}>
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No brands found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
        {renderPagination()}
      </section>
    </>
  );
};

export default AllBrand;
